import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

const usePaymentsMVPEnabled = () => {
	const isPaymentsMVPEnabled = useFeatureToggle(FEATURES.paymentsMVP);
	return isPaymentsMVPEnabled;
};

export default usePaymentsMVPEnabled;
